import React from "react";
import BaseDropdown from "./BaseDropdown";

interface DropdownOption {
    value: string;
    label: string;
}

interface DropdownProps {
    label: string;
    options: DropdownOption[];
    selectedValue: string | null;
    onChange: (value: string | null) => void;
    placeholder?: string;
    loading?: boolean;
    disabled?: boolean;
    required?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
                                               label,
                                               options,
                                               selectedValue,
                                               onChange,
                                               placeholder,
                                               loading,
                                               disabled,
                                               required,
                                           }) => {
    const handleChange = (value: string | number | null) => {
        if (typeof value === "string" || value === null) {
            onChange(value); // Pass only string or null to onChange
        }
    };

    return (
        <BaseDropdown
            label={label}
            options={options}
            selectedValue={selectedValue}
            onChange={handleChange}
            placeholder={placeholder}
            loading={loading}
            disabled={disabled}
            required={required}
        />
    );
};

export default Dropdown;
